// extracted by mini-css-extract-plugin
export default {"container":"TopicView-module__container--CNtlH","isEditing":"TopicView-module__isEditing--mp646","animatedBackground":"TopicView-module__animatedBackground--mlrfW"};